import { Link } from "react-router-dom";
import useContent from "../lib/useContent";

const ALL_BRANDS = [
  "Rolex","Patek Philippe","Audemars Piguet","Richard Mille","Vacheron Constantin","A. Lange & Söhne",
  "Omega","Cartier","IWC","Hublot","Panerai","Breitling","TAG Heuer","Tudor","Zenith","Jaeger-LeCoultre",
  "Bvlgari","Chopard","Piaget","Longines","Tissot","Oris","Rado","Seiko","Grand Seiko","Citizen",
  "Hermès","Montblanc","Bell & Ross","Ulysse Nardin","Blancpain","Glashütte Original","Breguet","Chanel",
  "F.P. Journe","H. Moser & Cie","Maurice Lacroix","MB&F","Roger Dubuis","Frederique Constant",
  "Baume & Mercier","Ebel","Movado","Nomos","Sinn","Bremont","Christopher Ward","Speake-Marin",
  "Urwerk","Greubel Forsey","De Bethune","Czapek","Laurent Ferrier","Voutilainen",
];

export default function BrandsGrid() {
  const { data } = useContent("homepage_brands", {
    overline: "Manufactures",
    title: "A Collection of Over 50 Luxury Brands.",
    subtitle: "An unparalleled range of timepieces from globally renowned maisons. Heritage and avant-garde creators.",
    items: ALL_BRANDS.map((b) => ({ name: b })),
  });
  const items = (data?.items?.length ? data.items : ALL_BRANDS.map((b) => ({ name: b })))
    .map((b) => ({ ...b, name: b.name || b.label || "" }))
    .filter((b) => b.name);
  // Two copies for seamless loop
  const loop = [...items, ...items];

  return (
    <section className="bg-white border-y border-black/5 py-20">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="overline mb-3">{data?.overline || "Manufactures"}</div>
          <h2 className="font-display text-4xl md:text-5xl text-dark tracking-tight">{data?.title || "A Collection of Over 50 Luxury Brands."}</h2>
          {data?.subtitle && <p className="text-gray-600 mt-5 text-sm">{data.subtitle}</p>}
        </div>
      </div>

      {/* Continuous marquee — pauses on hover */}
      <div data-testid="brands-marquee" className="brands-marquee relative overflow-hidden">
        <div className="brands-marquee-track flex items-center gap-12 md:gap-16 px-8 will-change-transform">
          {loop.map((b, i) => (
            <Link
              key={`${b.name}-${i}`}
              to={b.href || `/shop?q=${encodeURIComponent(b.name)}`}
              data-testid={i < items.length ? `brand-${b.name}` : undefined}
              className="shrink-0 group"
              aria-label={b.name}
            >
              {b.logo ? (
                <img src={b.logo} alt={b.name} className="h-10 md:h-12 max-w-[160px] object-contain grayscale group-hover:grayscale-0 opacity-70 group-hover:opacity-100 transition-all"/>
              ) : (
                <span className="font-display text-base md:text-lg whitespace-nowrap text-gray-700 group-hover:text-copper transition-colors">{b.name}</span>
              )}
            </Link>
          ))}
        </div>
        {/* Edge fades for elegance */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 md:w-24 bg-gradient-to-r from-white to-transparent"/>
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 md:w-24 bg-gradient-to-l from-white to-transparent"/>
      </div>

      <div className="text-center mt-10"><Link to="/shop" className="text-xs uppercase tracking-luxe text-copper hover:text-[#A0834F]">View All Brands →</Link></div>
    </section>
  );
}
